import { useQuery } from '@tanstack/react-query'

import * as walletServices from '../walletServices'
import { CryptoAddressWithdrawParams } from '../walletTypes'

import { QUERY_KEYS } from '@/constants/queryKeys'

export const useFetchWithdrawCryptoAddressByNetworkCode = (
  params: CryptoAddressWithdrawParams,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.WITHDRAW_CRYPTO_ADDRESSES, params],
    queryFn: () =>
      walletServices.fetchWithdrawCryptoAddressByNetworkCode(params),
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!params.networkCode,
  })
